<template>
  <component v-bind:is="popupType" :popupData="popupData"></component>
</template>

<script>
import AssertFollowingWords from "./assertFollowingWords";
import CreateVademecum from "./createVademecum.vue";
import DoCaptcha from "./doCaptcha.vue";
import EditDisabled from "./editDisabled.vue";
import Error from "./error.vue";
import LetsGo from "./letsGo.vue";
import Search from "./search.vue";

export default {
  props: {
    popupType: String,
    popupData: {
      default: null,
      type: Object,
    },
  },
  components: {
    "pop-up-edit-disabled": EditDisabled,
    "pop-up-create-vademecum": CreateVademecum,
    "pop-up-lets-go": LetsGo,
    "pop-up-do-captcha": DoCaptcha,
    "pop-up-search": Search,
    "pop-up-error": Error,
    "pop-up-assert-following-words": AssertFollowingWords,
  },
};
</script>

<style>
.bigText {
  font-size: 0.8em;
}

.mediumText {
  font-size: 0.6em;
}

.smallText {
  font-size: 0.4em;
}

@media (max-width: 1000px) {
  .bigText {
    font-size: 1em;
  }

  .mediumText {
    font-size: 0.8em;
  }

  .smallText {
    font-size: 0.6em;
  }
}
</style>
